import { useEffect, useState, useCallback } from "react";
import { savePrefParams } from "./types";
import { selectUserEmail } from "@store/userData/selectors";
import { useParams } from "react-router-dom";
import { useParamsInterface } from "@store/types";
import { useSelector } from "react-redux";
import {
  savePrefHandlerCallback,
  setGridPerferencesHandlerCallback,
} from "./utils";

export const useAccordionGridPreferences = (
  gridKey: string,
  isAccordionOpen: boolean
) => {
  const [canBeSaved, setCanBeSaved] = useState(false);
  const { account } = useParams<useParamsInterface>();

  useEffect(() => {
    setCanBeSaved(false);
  }, [account]);

  useEffect(() => {
    if (!isAccordionOpen) setCanBeSaved(false);
  }, [isAccordionOpen]);

  const userEmail = useSelector(selectUserEmail);
  const localStorageKey = `${userEmail}-${gridKey}`;

  // Handler to check and apply Grid states on initial load

  const setGridPerferencesHandler = useCallback(
    (params) => {
      setGridPerferencesHandlerCallback(params, localStorageKey, setCanBeSaved);
    },
    [localStorageKey]
  );

  // Handler to save Grid states

  const savePrefHandler = useCallback(
    (params: savePrefParams) => {
      savePrefHandlerCallback(params, canBeSaved, localStorageKey);
    },
    [canBeSaved, localStorageKey]
  );

  return {
    setGridPerferencesHandler,
    savePrefHandler,
  };
};
